import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	recentlyViewedIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recentlyViewedIssuesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueErrorIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	recentlyViewedIssues: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.recently-viewed-issues',
		defaultMessage: 'Recently Viewed Issues',
		description: 'Section title for recently viewed issues',
	},
	issueError: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.issue-error',
		defaultMessage:
			"We're having trouble loading recently viewed issues. Try again in a few moments.",
		description: 'Error message if getting recent issue api fails',
	},
	recentlyViewedIssuesIssueTermRefresh: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.recently-viewed-issues-issue-term-refresh',
		defaultMessage: 'Recently viewed work items',
		description: 'Section title for recently viewed issues',
	},
	issueErrorIssueTermRefresh: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.issue-error-issue-term-refresh',
		defaultMessage:
			"We're having trouble loading recently viewed work items. Try again in a few moments.",
		description: 'Error message if getting recent issue api fails',
	},
});
